import ListBuilderModal from "../WidgetsSettings/ListBuilder/ListBuilderModal";
import ListBuilderController from "./ListBuilderController";
import SettingsModal from "../../Modal/SettingsModal";
import Widget from "../../Widget/Widget";

import { FormBuilderProvider } from "../FormBuilder/FormBuilderContext";
import { ListBuilderProvider } from "../../../context/ListBuilderContext/ListBuilderContext";

import "./ListBuilder.less";

interface ListBuilderControlleWidget {
   value: any;
   role: any;
}

const ListBuilderWidget: React.FC<ListBuilderControlleWidget> = ({ value, role }) => {
   return (
      <ListBuilderProvider>
         <FormBuilderProvider>
            <Widget
               title={value?.title}
               role={role}
               hideCardHead={role === "OWNER" ? false : true}
               extra={
                  (role === "OWNER" || role === "MODERATOR") && (
                     //@ts-ignore
                     <SettingsModal
                        widgetName={value.name}
                        widgetId={value.id}
                        icon="setting"
                        deleteIcon="true"
                        children={<ListBuilderModal value={value} />}
                     />
                  )
               }
               className="list-builder-widget"
               children={<ListBuilderController />}
            />
         </FormBuilderProvider>
      </ListBuilderProvider>
   );
};

export default ListBuilderWidget;
